<div class="left-sport-menu-header leftmenulinksheader">
  {{ 'soon' | t }}
</div>
<ul class="forSafari leftmenulinks">
  <ng-container *ngFor="let item of procesedData | sortBy : true : 'Position'">
    <li class="left-sport-menu-li leftlinkli" (click)="onClickItem(item)">
      <div class="text sportmenutitle">
        <img class="leftmenulinkimg" src="images/target.svg" alt="{{ item.Title }}" />
      </div>
      <p style="flex-grow: 1" class="text verticalAligner">{{ item.Title }}</p>
    </li>
  </ng-container>
</ul>
